import { Box, styled } from "@mui/material";

export const PopupContainer = styled(Box)`
  min-width: 300px;
  overflow: auto;
  min-height: 0;
  max-height: 300px;
  max-width: 400px;
`;
